import React from 'react';

const steps = [
  { n: '01', title: 'Onboard & connect', bullets: ['Import via API, CSV, or CRM', 'Salesforce & Calabrio native', 'Dedicated onboarding support'], },
  { n: '02', title: 'Configure & segment', bullets: ['SQL-based lead targeting', 'Set CLI rotation rules', 'Build agent scripts & flows'], },
  { n: '03', title: 'Dial & optimise', bullets: ['Go live with full monitoring', 'Outcome engine auto-retries', 'Real-time performance data'], },
];

export default function HowItWorks() {
  return (
    <div id="features" style={{ background: '#0a0a0a', borderTop: '1px solid rgba(10,158,143,0.13)', borderBottom: '1px solid rgba(10,158,143,0.13)' }}>
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '5rem 2.5rem' }}>
        <div style={tag}>// DEPLOYMENT</div>
        <h2 style={head}>Up and running <span style={{ color: '#0a9e8f' }}>in days, not months.</span></h2>
        <div className="howitworks-grid" style={{ marginTop: '2.5rem', background: 'rgba(10,158,143,0.13)', borderRadius: 12, overflow: 'hidden' }}>
          {steps.map((s, i) => (
            <div key={i} style={{ background: '#060606', padding: '2rem', position: 'relative', transition: 'background .2s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#0a0a0a'}
              onMouseLeave={e => e.currentTarget.style.background = '#060606'}>
              <div style={{ fontSize: '3.5rem', fontWeight: 700, color: 'rgba(10,158,143,0.25)', fontFamily: "'JetBrains Mono', monospace", lineHeight: 1, marginBottom: 8 }}>{s.n}</div>
              <div style={{ width: 28, height: 2, background: '#056055', marginBottom: '1rem', borderRadius: 2 }} />
              <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: '#f0f0f0', marginBottom: '1rem' }}>{s.title}</div>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {s.bullets.map((b, j) => (
                  <li key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.8rem', color: '#c0c0c0', fontWeight: 300 }}>
                    <span style={{ width: 4, height: 4, borderRadius: '50%', background: '#077a6e', flexShrink: 0 }} />
                    {b}
                  </li>
                ))}
              </ul>
              {i < 2 && (
                <div className="step-arrow" style={{ position: 'absolute', right: -11, top: '50%', transform: 'translateY(-50%)', width: 22, height: 22, background: '#0a0a0a', border: '1px solid rgba(10,158,143,0.28)', borderRadius: '50%', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#0a9e8f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const tag = { fontSize: '0.68rem', color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: 12, borderLeft: '2px solid #056055', paddingLeft: 10 };
const head = { fontSize: 'clamp(1.6rem,3vw,2.2rem)', fontWeight: 700, letterSpacing: '-0.03em', color: '#f0f0f0' };
